import {
  GET_USER_INFORMATION,
  IS_GETTING_USER_INFO,
  GET_USER_INFORMATION_FAILURE,
  SIGN_IN,
  CONTINUE_AS_GUEST,
  SET_LOGGIN_LOADING,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  user: null,
  guest: true,
  isGettingUserInfo: false,
  errors: null,
  authError: null,
  isLoggingIn: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SIGN_IN: {
      return {
        ...state,
        user: action.payload,
      };
    }
    case SET_LOGGIN_LOADING: {
      return {
        ...state,
        isLoggingIn: action.payload,
        authError: action.authError,
      };
    }
    case GET_USER_INFORMATION: {
      return {
        ...state,
        user: action.payload,
      };
    }
    case IS_GETTING_USER_INFO: {
      return {
        ...state,
        isGettingUserInfo: action.payload,
      };
    }
    case GET_USER_INFORMATION_FAILURE: {
      return {
        ...state,
        user: null,
      };
    }
    case CONTINUE_AS_GUEST: {
      return {
        ...state,
        guest: action.payload,
      };
    }
    default:
      return state;
  }
};
